import PropTypes from 'prop-types';

var propTypes = {
    content: PropTypes.node.isRequired,
    className: PropTypes.string,
    onRequestClose: PropTypes.func,
    iconAlt: PropTypes.string,
    alignCenter: PropTypes.bool,
};
var defaultProps = {
    iconAlt: 'CloseModal',
    alignCenter: false,
};

export { defaultProps, propTypes };
